/**
 * Envío AP-7 · búsqueda y filtros de la biblioteca de stickers (pura).
 */
export const PAGE = 120;

export const fold = (s) => String(s || '').toLowerCase()
  .normalize('NFD').replace(/[̀-ͯ]/g, '').trim();

/** Filtra por categoría y por todas las palabras buscadas (nombre o claves). */
export function filterStickers(list, { cat = 'all', q = '' } = {}) {
  const terms = fold(q).split(/\s+/).filter(Boolean);
  return (list || []).filter((s) => {
    if (cat !== 'all' && s.cat !== cat) return false;
    if (!terms.length) return true;
    const hay = fold(`${s.label} ${s.kw || ''}`);
    return terms.every((t) => hay.includes(t));
  });
}

/** Categorías con al menos un sticker, en el orden del pack. */
export function categoriesOf(list, packCategories = {}) {
  const present = new Set((list || []).map((s) => s.cat));
  return Object.entries(packCategories).filter(([id]) => present.has(id));
}
